<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="product/category/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="CategoryForm"
        >
          <template>
            <v-row v-if="item.id">
              <v-col cols="120">
                <v-img
                    @click="change_logo_dialog = true"
                    class="mr-2"
                    style="cursor: pointer"
                    v-if="!item.picture"
                    contain
                    max-height="90"
                    max-width="90"
                    src="/img/icons/photo.svg"
                />
                <v-avatar class="mr-2" v-if="item.picture" size="100" style="cursor: pointer"
                          @click="change_logo_dialog = true">
                  <v-img class="rounded-lg" :src="img_source(item.picture)" />
                </v-avatar>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="120">
                <category-select
                    class="rounded-lg"
                    label="دسته بندی مادر"
                    v-model="item.parent"
                    :disabled="!isEditing"

                ></category-select>

              </v-col>
            </v-row>
            <v-row>
              <v-col cols="120">
                <v-text-field label="نام دسته بندی "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>


              </v-col>
            </v-row>
          </template>
        </m-form>
        <v-row justify="center">
          <v-dialog
              v-model="change_logo_dialog"
              class="rounded-lg"
              persistent
              @click:outside="change_logo_dialog=false"
              max-width="400"
          >
            <v-card class="rounded-lg pa-2">
              <v-card-title class="primary--text text-h5">
                تغییر عکس دسته بندی
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <m-file-input
                        label="انتخاب عکس"
                        v-model="logo"
                        :delete-attachment.sync="delete_logo"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="change_logo_dialog = false"
                >
                  بستن
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="updateLogo(item)"
                >
                  تغییر عکس
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import CategorySelect from "@/components/selects/CategorySelect";


export default {
  name: "CategoryForm",
  components: {CategorySelect},
  mixins: [MFormMixin,  formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'product/category/all',
      baseUrl: "product/category",
      permissionBasename: "category",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      delete_logo: null,
      logo: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      change_logo_dialog: false,
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "نام",
          value: "name",
        },
        {
          text: "دسته بندی مادر",
          value: "parent_name",
        },
      ],

    };
  },
  computed: {
    title(){
      return 'دسته بندی محصول'
    },
    headers() {
      return [];
    },
  },
  methods: {
    getUpdateLogoSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        picture: this.logo,
        delete_picture: this.delete_logo,
      };

      if (typeof item["logo"] == typeof "") {
        delete item["logo"];
      }

      return this.jsonToFormData(item);
    },

    updateLogo(selectItem) {
      this.request({
        url: this.endpoint(`product/categoryPictureUpdate/${selectItem.id}`),
        method: "put",
        data: this.getUpdateLogoSerialized(selectItem),
        success: () => {
          this.successNotify();
          this.isEditing = false;
          this.change_logo_dialog = false
          this.$refs.CategoryForm.$refs.datatable.getDataFromApi()
          this.setItem(data)
        },
      });
    },
  },
}
</script>

<style scoped lang="scss"></style>

